var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H13.25V20C13.25 20.3034 13.4327 20.5768 13.713 20.6929C13.9932 20.809 14.3158 20.7449 14.5303 20.5304L22.5303 12.5304C22.671 12.3897 22.75 12.1989 22.75 12C22.75 11.8011 22.671 11.6103 22.5303 11.4697L14.5303 3.46969C14.3158 3.25519 13.9932 3.19103 13.713 3.30711C13.4327 3.4232 13.25 3.69668 13.25 4.00002V11.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.00006C1.25 6.58585 1.58579 6.25006 2 6.25006L10 6.25007C10.4142 6.25007 10.75 6.58585 10.75 7.00007C10.75 7.41428 10.4142 7.75006 10 7.75006H2C1.58579 7.75006 1.25 7.41428 1.25 7.00006Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.25C1.58579 16.25 1.25 16.5858 1.25 17C1.25 17.4143 1.58579 17.75 2 17.75H10C10.4142 17.75 10.75 17.4143 10.75 17C10.75 16.5858 10.4142 16.25 10 16.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveRight);
export default __webpack_public_path__ + "static/media/move-right.b19262ed6d38c55ec6c3253814bf9865.svg";
export { ForwardRef as ReactComponent };